import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { VideoCard } from "@/components/VideoCard";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function Saved() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    let active = true;
    api
      .get("/saved")
      .then(({ data }) => { if (active) setItems(data.items || []); })
      .catch(() => { if (active) setItems([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [user]);

  if (user === null) return null; // still checking

  if (user === false) {
    return (
      <>
        <Header />
        <div className="px-6 py-20 text-center" data-testid="saved-login-prompt">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-brand to-orange-500 mx-auto grid place-items-center shadow-xl shadow-brand/40 mb-5">
            <Heart size={28} fill="white" />
          </div>
          <h2 className="font-heading text-2xl font-bold">Save what you love</h2>
          <p className="text-white/55 text-sm mt-2 mb-6">Sign in to bookmark videos and find them later.</p>
          <Link
            to="/login"
            data-testid="login-redirect-btn"
            className="inline-block bg-brand text-white font-semibold px-6 py-3 rounded-full shadow-[0_0_20px_rgba(230,59,46,0.45)] hover:bg-brand-hover transition"
          >
            Log in or sign up
          </Link>
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="px-4 pt-2 pb-3">
        <h1 className="font-heading text-3xl font-bold">Saved</h1>
        <p className="text-white/55 text-sm">Your bookmarked DeshFlix videos</p>
      </div>
      {loading ? (
        <div className="grid grid-cols-1 gap-5 px-4 mt-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="aspect-video rounded-xl bg-bg-surface animate-pulse" />
          ))}
        </div>
      ) : items.length === 0 ? (
        <p className="text-white/40 text-sm text-center py-16">No saved videos yet. Tap the heart on any card.</p>
      ) : (
        <div className="grid grid-cols-1 gap-5 px-4 mt-2" data-testid="saved-list">
          {items.map((v) => (
            <VideoCard
              key={v.video_id}
              video={v}
              variant="full"
              onUnsave={(id) => setItems((arr) => arr.filter((x) => x.video_id !== id))}
            />
          ))}
        </div>
      )}
    </>
  );
}
